import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { ShippingRulePresetApplication } from '../../models/ShippingRulePresetApplication';
import { HistoryCard } from './HistoryCard';

interface HistoryCardListProps {
  applications: ShippingRulePresetApplication[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
}

// Listado mobile de historial de aplicaciones (patrón similar a Orders/List)
export const HistoryCardList = ({
  applications,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
}: HistoryCardListProps) => {
  const { t } = useTranslation('shippingRulePresetsModule');

  const renderHistoryCard = (props: RenderItemProps<ShippingRulePresetApplication>) => <HistoryCard {...props} />;

  return (
    <VirtualList
      data={applications}
      renderItem={renderHistoryCard}
      itemKey={(item) => item.id}
      estimateItemHeight={130}
      height="calc(100vh - 260px)"
      gap={0}
      emptyMessage={t('history.empty.description')}
      className="rounded-lg shadow-sm"
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={300}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
